export default [
  {
    path: "/notebooks",
    name: "notebookSearch",
    component: () =>
      import(/* webpackChunkName: "notebooks" */ "@/views/notebooks/Search.vue"),
    meta: {
      layout: "Split",
      requiresAuth: true,
      showBack: true
    }
  },
  {
    path: "/notebooks/edit/:id",
    name: "notebookEditPage",
    component: () =>
      import(/* webpackChunkName: "notebooks" */ "@/views/notebooks/NotebookEdit.vue"),
    meta: {
      layout: "Split",
      requiresAuth: true,
      showBack: true
    }
  },
  {
    path: "/notebooks/edit",
    name: "notebookCreatePage",
    component: () =>
      import(/* webpackChunkName: "notebooks" */ "@/views/notebooks/NotebookEdit.vue"),
    meta: {
      layout: "Split",
      requiresAuth: true,
      showBack: true
    }
  },
  {
    path: "/notebooks/:id",
    name: "notebookPage",
    component: () =>
      import(/* webpackChunkName: "notebooks" */ "@/views/notebooks/Notebook.vue"),
    meta: {
      layout: "Split",
      requiresAuth: true,
      showBack: true
    }
  }
];
